import { fetchShipbackApi, updateSizeApi, updateModeApi, setDropoffApi, setPickupApi, payShipbackApi, freeShipbackApi } from './api'
import { DROPOFF, PICKUP, INSTRUCTIONS, SHIPPING, RETURNS } from '../assets/constant'
import { setBreadcrumb } from './breadcrumb'

export const SET_SHIPBACK = 'SET_SHIPBACK';
export const UPDATE_SHIPBACK = 'UPDATE_SHIPBACK';


function updatingShipback() {
  return {
    type: UPDATE_SHIPBACK,
  };
}

function setShipback(shipback) {
  return {
    type: SET_SHIPBACK,
    shipback: shipback
  };
}

export function fetchShipback(shipback_id, user_token, tracking = false, fetch = false) {
  return function (dispatch) {
    dispatch(updatingShipback())
    return fetchShipbackApi(shipback_id, user_token)
    .then(json => {
        dispatch(setShipback(json))
        if (!tracking) {
          if (json.charged) {
            dispatch(setBreadcrumb(INSTRUCTIONS))
          }
          else if (json.returned_items.length > 0 && json.size != undefined) {
            dispatch(setBreadcrumb(SHIPPING))
          } else {
            dispatch(setBreadcrumb(RETURNS))
          }
        }
      }
    )
  }
}

export function updateSize(size, shipback_id, user_token) {
  return function (dispatch) {
    dispatch(updatingShipback())
    return updateSizeApi(size, shipback_id, user_token)
    .then(json =>
      dispatch(setShipback(json))
    )
  }
}

export function updateMode(mode, shipback_id, user_token) {
  return function (dispatch) {
    dispatch(updatingShipback())
    return updateModeApi(mode, shipback_id, user_token)
    .then(json =>
      dispatch(setShipback(json))
    )
  }
}

export function setDropoff(dropoff_code, shipback_id, user_token) {
  return function (dispatch) {
    dispatch(updatingShipback())
    return setDropoffApi(dropoff_code, shipback_id, user_token)
    .then(json =>
      dispatch(setShipback(json))
    )
  }
}

export function setPickup(pickup_datetime, pickup_duration, pickup_slot_id, shipback_id, user_token) {
  return function (dispatch) {
    return setPickupApi(pickup_datetime, pickup_duration, pickup_slot_id, shipback_id, user_token)
    .then(json =>
      dispatch(setShipback(json))
    )
  }
}

export function payShipback(payment_method_id, shipback_id, user_token) {
  return function (dispatch) {
    dispatch(updatingShipback())
    return payShipbackApi(payment_method_id, shipback_id, user_token);
  }
}

export function freeShipback(shipback_id, user_token) {
  return function (dispatch) {
    dispatch(updatingShipback())
    return freeShipbackApi(shipback_id, user_token).then(() => {
      fetchShipbackApi(shipback_id, user_token).then(json => {
        dispatch(setShipback(json))
      });
    });
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/actions/shipback.js